<div class="log" [style.minHeight.px]="minScrollHeight" #logContainer>
  <div class="virtual-scroll-container" [style.marginBottom.px]="bottomSpace" #messageContainer>
    <ng-container *ngIf="0 < chatMessages.length">
      <ng-container *ngFor="let chatMessage of chatMessages; last as last; trackBy: trackByChatMessage">
        <chat-message *ngIf="chatMessage.isDisplayable" [chatMessage]="chatMessage" [compact]="compact" [@.disabled]="compact || !last">
        </chat-message>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="chatMessages.length <= 0">
      <chat-message *ngFor="let chatMessage of sampleMessages; last as last" [chatMessage]="chatMessage" [compact]="compact" [@.disabled]="compact || !last">
      </chat-message>
    </ng-container>
  </div>
</div>